export const SaveSummarySectionTitle = {
  WILL_BE_SAVED: 'Will be saved',
  ALSO_CHANGED: 'Also changed by someone else',
  STAYS_PENDING: 'Stays pending',
};

export const SaveSummarySectionVariant = {
  DEFAULT: 'default',
  WARNING: 'warning',
};
